module.exports = __webpack_public_path__ + "media/images/bg-cardboard-a4a055a16947cf7d7b61aeb36eabd79f.png";